import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'DEVICE_QUICK_LOGIN_ALL',
        delete: 'DEVICE_QUICK_LOGIN_DELETE'
      },
      permission: {
        query: '',
        add: 'sms:call:record:add',
        edit: 'sms:call:record:edit',
        detail: '',
        remove: 'sms:call:record:remove'
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      return [{
        prop: 'device_number',
        label: 'device_number',
        width: '120px'
      }, {
        prop: 'user_name',
        label: 'user_name',
        width: '120px'
      }, {
        prop: 'token',
        label: 'token',
        minWidth: '120px'
      }, {
        prop: 'time',
        label: 'time',
        minWidth: '120px',
        formatter: function formatter(row) {
          return utils.time.format1(row.time, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'status',
        label: 'status',
        minWidth: '120px'
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      return function (_ref) {
        var row = _ref.row;
        return [// ...this.p('edit', [{ icon: 'el-icon-edit-outline', action: () => this.edit(row.id) }], []),
          // ...this.p('remove', [{ icon: 'el-icon-delete', type: 'danger', confirm: this.$t('confirm_delete_info'), action: () => this.delete(row.id) }], [])
        ];
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this2 = this;

      var h = this.$createElement;
      return [{
        prop: 'device_number',
        label: 'device_number',
        default: this.device_number,
        render: function render() {
          return h("el-input", {
            "style": "width:300px;",
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this2.search.form.model.device_number,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "device_number", $$v);
              }
            }
          });
        }
      }, {
        prop: 'start_time',
        label: 'start_time',
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this2.search.form.model.start_time,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: 'end_time',
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this2.search.form.model.end_time,
              callback: function callback($$v) {
                _this2.$set(_this2.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    },
    // [本页面特有] 父级字典项目的 id 强制转为数字
    device_number: function device_number() {
      return this.$route.query.device_number;
    }
  },
  methods: _objectSpread({}, mapActions('d2admin/page', ['closeBy']))
};